import axios from "./axios";
import { call, put, takeLatest, spawn, select } from "redux-saga/effects";
import {
  SET_CURRENCY_RATE_REQUEST,
  SET_SYSTEM_CURRENCY_REQUEST,
  GET_CURRENCY_RATES_REQUEST,
  GET_SYSTEM_CURRENCY_REQUEST,
  DEACTIVATE_CURRENCY_RATE_REQUEST,
  DELETE_CURRENCY_RATE_REQUEST,
} from "../types";
import { clientErrorMessage, delay } from "./reusable";
import {
  setCurrencyRateFailure,
  setCurrencyRateLoading,
  setCurrencyRateSuccess,
  setSystemCurrencyFailure,
  setSystemCurrencyLoading,
  setSystemCurrencySuccess,
  getCurrencyRatesFailure,
  getCurrencyRatesLoading,
  getCurrencyRatesSuccess,
  getSystemCurrencyFailure,
  getSystemCurrencyLoading,
  getSystemCurrencySuccess,
  deactivateCurrencyRateFailure,
  deactivateCurrencyRateLoading,
  deactivateCurrencyRateSuccess,
  deleteCurrencyRateFailure,
  deleteCurrencyRateLoading,
  deleteCurrencyRateSuccess,
} from "../action";

// Selector to get token from store
const getToken = (state) => state.userData.token;

const ajaxDBCalls = {
  setCurrencyRate: async (formData, token) => {
    const response = await axios.post(`/currency/set-rate`, formData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
  setSystemCurrency: async (formData, token) => {
    const response = await axios.post(
      `/currency/set-system-currency`,
      formData,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  getCurrencyRates: async () => {
    const response = await axios.get(`/currency/rates`);
    return response;
  },
  getSystemCurrency: async () => {
    const response = await axios.get(`/currency/system-currency`);
    return response;
  },
  deactivateCurrencyRate: async (rateId, token) => {
    const response = await axios.put(
      `/currency/deactivate/${rateId}`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  deleteCurrencyRate: async (rateId, token) => {
    const response = await axios.delete(`/currency/delete/${rateId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
};

function* setCurrencyRate({ payload }) {
  try {
    yield put(setCurrencyRateLoading(true));

    // Get token from store
    const token = yield select(getToken);

    const res = yield call(ajaxDBCalls.setCurrencyRate, payload, token);

    yield put(setCurrencyRateSuccess(res.data));

    yield put(setCurrencyRateLoading(false));
  } catch (err) {
    let errorMessage = "";
    if (err.request) errorMessage = clientErrorMessage;

    if (err.response) {
      console.log("something is wrong", err.response.data);

      const { message } = err.response.data;
      errorMessage = message;
    }

    yield put(setCurrencyRateFailure(errorMessage));
    yield put(setCurrencyRateLoading(false));
    yield delay();
    yield put(setCurrencyRateFailure(""));
  }
}

function* setSystemCurrency({ payload }) {
  try {
    yield put(setSystemCurrencyLoading(true));

    // Get token from store
    const token = yield select(getToken);

    const res = yield call(ajaxDBCalls.setSystemCurrency, payload, token);

    yield put(setSystemCurrencySuccess(res.data));

    yield put(setSystemCurrencyLoading(false));
  } catch (err) {
    let errorMessage = "";
    if (err.request) errorMessage = clientErrorMessage;

    if (err.response) {
      console.log("something is wrong", err.response.data);

      const { message } = err.response.data;
      errorMessage = message;
    }

    yield put(setSystemCurrencyFailure(errorMessage));
    yield put(setSystemCurrencyLoading(false));
    yield delay();
    yield put(setSystemCurrencyFailure(""));
  }
}

function* getCurrencyRates() {
  try {
    yield put(getCurrencyRatesLoading(true));

    const res = yield call(ajaxDBCalls.getCurrencyRates);

    yield put(getCurrencyRatesSuccess(res.data));

    yield put(getCurrencyRatesLoading(false));
  } catch (err) {
    let errorMessage = "";
    if (err.request) errorMessage = clientErrorMessage;

    if (err.response) {
      console.log("something is wrong", err.response.data);

      const { message } = err.response.data;
      errorMessage = message;
    }

    yield put(getCurrencyRatesFailure(errorMessage));
    yield put(getCurrencyRatesLoading(false));
    yield delay();
    yield put(getCurrencyRatesFailure(""));
  }
}

function* getSystemCurrency() {
  try {
    yield put(getSystemCurrencyLoading(true));

    const res = yield call(ajaxDBCalls.getSystemCurrency);

    yield put(getSystemCurrencySuccess(res.data));

    yield put(getSystemCurrencyLoading(false));
  } catch (err) {
    let errorMessage = "";
    if (err.request) errorMessage = clientErrorMessage;

    if (err.response) {
      console.log("something is wrong", err.response.data);

      const { message } = err.response.data;
      errorMessage = message;
    }

    yield put(getSystemCurrencyFailure(errorMessage));
    yield put(getSystemCurrencyLoading(false));
    yield delay();
    yield put(getSystemCurrencyFailure(""));
  }
}

function* deactivateCurrencyRate({ payload }) {
  try {
    yield put(deactivateCurrencyRateLoading(true));

    // Get token from store
    const token = yield select(getToken);

    const res = yield call(ajaxDBCalls.deactivateCurrencyRate, payload, token);

    yield put(deactivateCurrencyRateSuccess(res.data));

    yield put(deactivateCurrencyRateLoading(false));
  } catch (err) {
    let errorMessage = "";
    if (err.request) errorMessage = clientErrorMessage;

    if (err.response) {
      console.log("something is wrong", err.response.data);

      const { message } = err.response.data;
      errorMessage = message;
    }

    yield put(deactivateCurrencyRateFailure(errorMessage));
    yield put(deactivateCurrencyRateLoading(false));
    yield delay();
    yield put(deactivateCurrencyRateFailure(""));
  }
}

function* deleteCurrencyRate({ payload }) {
  try {
    yield put(deleteCurrencyRateLoading(true));

    // Get token from store
    const token = yield select(getToken);

    const res = yield call(ajaxDBCalls.deleteCurrencyRate, payload, token);

    yield put(deleteCurrencyRateSuccess(res.data));

    yield put(deleteCurrencyRateLoading(false));
  } catch (err) {
    let errorMessage = "";
    if (err.request) errorMessage = clientErrorMessage;

    if (err.response) {
      console.log("something is wrong", err.response.data);

      const { message } = err.response.data;
      errorMessage = message;
    }

    yield put(deleteCurrencyRateFailure(errorMessage));
    yield put(deleteCurrencyRateLoading(false));
    yield delay();
    yield put(deleteCurrencyRateFailure(""));
  }
}

//Watchers
function* setCurrencyRateWatcher() {
  yield takeLatest(SET_CURRENCY_RATE_REQUEST, setCurrencyRate);
}

function* setSystemCurrencyWatcher() {
  yield takeLatest(SET_SYSTEM_CURRENCY_REQUEST, setSystemCurrency);
}

function* getCurrencyRatesWatcher() {
  yield takeLatest(GET_CURRENCY_RATES_REQUEST, getCurrencyRates);
}

function* getSystemCurrencyWatcher() {
  yield takeLatest(GET_SYSTEM_CURRENCY_REQUEST, getSystemCurrency);
}

function* deactivateCurrencyRateWatcher() {
  yield takeLatest(DEACTIVATE_CURRENCY_RATE_REQUEST, deactivateCurrencyRate);
}

function* deleteCurrencyRateWatcher() {
  yield takeLatest(DELETE_CURRENCY_RATE_REQUEST, deleteCurrencyRate);
}

export default function* currencySagas() {
  yield spawn(setCurrencyRateWatcher);
  yield spawn(setSystemCurrencyWatcher);
  yield spawn(getCurrencyRatesWatcher);
  yield spawn(getSystemCurrencyWatcher);
  yield spawn(deactivateCurrencyRateWatcher);
  yield spawn(deleteCurrencyRateWatcher);
}
